<template>
  <div class="wrapper">
    <video
      :poster="poster"
      muted="muted"
      playsinline
      loop
      autoplay
      class="video"
      :src="src"
      type="video/mp4"
    >
      <!-- <source
        :src="src"
        type="video/mp4"
      > -->
    </video>
    <div
      class="overlay overlay-png"
      :style="`opacity: ${pngOverlayOpacity}`"
    />
    <div
      class="overlay"
      :class="overlayColor"
      :style="`opacity: ${overlayOpacity}`"
    />
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: [ String, Boolean ],
      default: 'uploads/looping-background.mp4'
    },
    pngOverlayOpacity: {
      type: Number,
      default: 0.6
    },
    overlayOpacity: {
      type: Number,
      default: 0.8
    },
    overlayColor: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* .wrapper {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
} */

.video {
  height: auto;
  left: 50%;
  max-height: none;
  max-width: none;
  min-height: 100%;
  min-width: 100%;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto;
}

.overlay {
  min-height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  min-width: 100%;
}

.overlay-png {
  background-image: url('../../src/assets/video-overlay.png');
}
</style>
